var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarouselArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.25 14.141"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 171",
    d: "M11.567.242L.244 11.565a.77.77 0 00-.244.559.768.768 0 00.244.559l1.215 1.215a.766.766 0 00.559.242.763.763 0 00.557-.242l9.55-9.55 9.55 9.55a.764.764 0 001.116 0l1.215-1.215a.766.766 0 000-1.118L12.685.242a.766.766 0 00-1.118 0",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "34ecb029b525d6faf023870071882e69.svg";
export { SvgCarouselArrowUp as ReactComponent };